export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6986.b5a5af9b.jpg";